import CellWrapper from '@common-components/tasks/columns-cells/cell-wrapper';
import { columnTypeList } from '@common-components/tasks/columns-cells/column-cell-defs';
import { logsSelectOneObjectByQuery, tasksSelectOneFieldById } from "@common-reducers/DBServiceThunks";
import { useAppSelector } from '@common-reducers/hooks/store.hook';
import { CSSProperties } from 'react';
import { LogStack } from '../../ExtraDataPanel';


type Props = {
    logId: string;
    isBoardLog?: boolean;
}

export default function DropdownColumnLog({
    logId,
    isBoardLog = false,
}: Props) {
    const log = useAppSelector((state) => logsSelectOneObjectByQuery(state.DBLogReducer, { _id: logId }))
    const taskName = useAppSelector(state => tasksSelectOneFieldById(state.DBTasksReducer, log?.taskId, 'text'))

    const cellWrapperStyle: CSSProperties = { pointerEvents: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center' }

    if (!log) {
        return null;
    }

    const cell = columnTypeList.find(
        (columnType) =>
            columnType.type === log.logUpdateType
    );

    if (!cell) {
        return null;
    }

    let status
    let oldValue
    let newValue
    if (!log.oldValue && log.newValue) {
        newValue = [{
            label: log.newValue
        }]
        status = 'add data'
    }
    if (log.oldValue && !log.newValue) {
        oldValue = [{
            label: log.oldValue
        }]
        status = 'remove data'
    }
    return (
        <LogStack>
            {status === 'add data' &&
                <>
                    <span>{log.actionType} </span>
                    <b style={cellWrapperStyle}><CellWrapper
                        columnId={""}
                        taskId={""}
                        groupId={""}
                        boardId={''}
                        mockValue={newValue}
                        readOnly={true}
                        cellComponent={cell.cellComponent}
                    /></b>
                    <span>to&nbsp;</span>
                </>
            }
            {status === 'remove data' &&
                <>
                    <span>{log.actionType} </span>
                    <b style={cellWrapperStyle}><CellWrapper
                        columnId={""}
                        taskId={""}
                        groupId={""}
                        boardId={''}
                        mockValue={oldValue}
                        readOnly={true}
                        cellComponent={cell.cellComponent}
                    /> </b>
                    <span>from&nbsp;</span>
                </>
            }
            {isBoardLog && <span style={{ fontWeight: 'bold' }}>{taskName as string}-</span>}
            <span style={{ fontWeight: 'bold' }}>{log.actionOnEntityData}</span>
        </LogStack>
    )
}


